import { render, staticRenderFns } from "./AddMachineWidget.vue?vue&type=template&id=3dd88cb1"
import script from "./AddMachineWidget.vue?vue&type=script&lang=js"
export * from "./AddMachineWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports